module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "sidebar-menu"
  }, [_vm._l((_vm.data), function(items, i) {
    return [_c('p', {
      key: items.category,
      staticClass: "sidebar-label"
    }, [_vm._v("\n                    " + _vm._s(items.category) + "\n                ")]), _vm._v(" "), _c('ul', {
      key: i
    }, _vm._l((_vm.normalizedData(items.pages)), function(item) {
      return _c('li', {
        key: item.title
      }, [(item.title) ? _c('router-link', {
        attrs: {
          "to": item.path
        }
      }, [_c('span', {
        staticClass: "sidebar-menu-text"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.isNew) ? _c('b-tag', {
        attrs: {
          "type": "is-success"
        }
      }, [_vm._v("New!")]) : _vm._e(), _vm._v(" "), (item.isUpdated) ? _c('b-tag', {
        attrs: {
          "type": "is-info"
        }
      }, [_vm._v("Updated")]) : _vm._e()], 1) : [_c('p', [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('ul', _vm._l((_vm.normalizedData(item.pages)), function(subItem) {
        return _c('li', {
          key: subItem.title
        }, [_c('router-link', {
          attrs: {
            "to": subItem.path
          }
        }, [_c('span', {
          staticClass: "sidebar-menu-text"
        }, [_vm._v(_vm._s(subItem.title))]), _vm._v(" "), (subItem.isNew) ? _c('b-tag', {
          attrs: {
            "type": "is-success"
          }
        }, [_vm._v("New!")]) : _vm._e(), _vm._v(" "), (subItem.isUpdated) ? _c('b-tag', {
          attrs: {
            "type": "is-info"
          }
        }, [_vm._v("\n                                            Updated\n                                        ")]) : _vm._e()], 1)], 1)
      }))]], 2)
    }))]
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btt",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.backToTop
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-expand-up",
      "size": "is-small"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Back to top")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3672dcb0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/components/TheSidebar.vue
// module id = 1599
// module chunks = 300